import React from 'react'
import PropTypes from 'prop-types'
import Grid from '../../../common/components/Grid'
import {FormControl} from 'material-ui/Form'
import Input, {InputLabel} from 'material-ui/Input'
import Button from 'material-ui/Button'
import TextField from 'material-ui/TextField'
import LoadingButton from '../../../common/components/LoadingButton'
import Dialog, {DialogTitle, DialogContent, DialogContentText, DialogActions} from 'material-ui/Dialog'
import Typography from 'material-ui/Typography'
import MaskedInput from 'react-text-mask'
import {changePhone as text} from '../text'
import compose from 'recompose/compose'
import withWidth from 'material-ui/utils/withWidth'
import {withStyles} from 'material-ui/styles/index'

const styles = (theme) => ({
  number: {
    fontSize: '1rem',
    alignItems: 'normal',
    position: 'relative',
    top: 7,
  },
  error: {
    color: 'red',
  },
})

class ChangePhoneDialog extends React.Component {

  static propTypes = {
    setOpenDialog: PropTypes.func,
    dialog: PropTypes.shape({
      show: PropTypes.bool,
      code: PropTypes.shape({
        value: PropTypes.string,
        error: PropTypes.string,
      }),
      isSaving: PropTypes.bool,
      isSending: PropTypes.bool,
      error: PropTypes.string,
    }),
    setCode: PropTypes.func,
    setNumber: PropTypes.func,
    number: PropTypes.shape({
      value: PropTypes.string,
    }),
    sendCode: PropTypes.func,
    save: PropTypes.func,
  }

  render() {
    const {classes} = this.props
    return (
      <Dialog
        open={this.props.dialog.show}
        onClose={() => this.props.setOpenDialog(false)}
      >
        <form>
          <DialogTitle>{text.dialog.title}</DialogTitle>
          <DialogContent>
            <DialogContentText>{text.dialog.body}</DialogContentText>
            <Grid container>
              <Grid item xs={12} sm={6}>
                <FormControl fullWidth>
                  <InputLabel htmlFor="phone">{text.dialog.labelPhoneNumber}</InputLabel>
                  <Input
                    id="phone"
                    type="tel"
                    autoFocus={true}
                    value={this.props.number.value}
                    onChange={e => this.props.setNumber(e.target.value)}
                    inputComponent={TextMaskCustom}
                  />
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  label={text.dialog.labelCode}
                  fullWidth
                  value={this.props.dialog.code.value}
                  onChange={e => this.props.setCode(e.target.value)}
                />
              </Grid>
            </Grid>
            {this.props.dialog.error !== '' ? (
              <Grid item xs={12}>
                <Typography className={classes.error}>{this.props.dialog.error}</Typography>
              </Grid>
            ) : null}
          </DialogContent>
          <DialogActions>
            <Button onClick={() => this.props.setOpenDialog(false)}>
              {text.dialog.cancel}
            </Button>
            <LoadingButton
              variant={this.props.dialog.code.value !== '' ? 'secondary' : 'primary'}
              isLoading={this.props.dialog.isSending}
              onClick={this.props.sendCode}
            >
              {text.dialog.sendAnotherCode}
            </LoadingButton>
            <LoadingButton
              variant={'primary'}
              disabled={this.props.dialog.code.value === ''}
              type="submit"
              isLoading={this.props.dialog.isSaving}
              onClick={e => {
                e.preventDefault()
                this.props.save()
              }}
            >
              {text.dialog.accept}
            </LoadingButton>
          </DialogActions>
        </form>
      </Dialog>
    )
  }
}

export default compose(withStyles(styles, {withTheme: true}), withWidth())(ChangePhoneDialog)

const TextMaskCustom = ({inputRef, ...other}) => (
  <MaskedInput
    {...other}
    ref={inputRef}
    mask={['+', /\d/, /\d/, ' ', '(', /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]}
    placeholderChar={'\u2000'}
    showMask={true}
  />
)



// WEBPACK FOOTER //
// ./src/sections/profile/components/ChangePhoneDialog.js